import { xFetch } from "../../helpers/xhrHelpers";
import { REQUEST_TYPE } from "../../constant";
import { getChequesHistorybyTransactionIdUrl } from "../../helpers/url/cheques";

const FETCH_CHEQUES_HISTORY_COMPLETED = "FETCH_CHEQUES_HISTORY_COMPLETED";
const FETCH_CHEQUES_HISTORY_COMPLETED_ERROR =
    "FETCH_CHEQUES_HISTORY_COMPLETED_ERROR";

export const fetchChequesTransactions = transaction_id => {
    return async dispatch => {
        let response = {};
        try {
            const url = getChequesHistorybyTransactionIdUrl(transaction_id);
            response = await xFetch({
                url: url,
                method: REQUEST_TYPE.GET
            });
            const { status } = response;
            if (status) {
                const { payload: { data = {} } = {} } = response;
                dispatch({
                    type: FETCH_CHEQUES_HISTORY_COMPLETED,
                    payload: data
                });
            }
        } catch (e) {
            dispatch({
                type: FETCH_CHEQUES_HISTORY_COMPLETED_ERROR
            });
        }

        return response;
    };
};

function setFundTransferTransactions(state, data) {
    const { cheque_history_transaction_id } = data;
    if (cheque_history_transaction_id) {
        return { ...state, ...cheque_history_transaction_id };
    }
    return state;
}

export default (state = {}, action = {}) => {
    const { type, payload = {} } = action;
    switch (type) {
        default:
            return setFundTransferTransactions(state, payload);
    }
};
